module.exports = __webpack_public_path__ + "static/MAI_DataReports_01-fd42b5d184ee5ef8a9409bcff59df4b1.gif";